<div
  *ngIf="open"
  class="dialog-backdrop"
  (click)="onBackdropClick($event)"
  (keydown)="onKeydown($event)"
>
  <div
    #dialogEl
    class="dialog"
    role="alertdialog"
    aria-modal="true"
    [attr.aria-labelledby]="'confirm-dialog-title'"
    [attr.aria-describedby]="message ? 'confirm-dialog-body' : null"
  >
    <span class="dialog-icon-tile" [ngClass]="tone === 'danger' ? 'tone-danger' : 'tone-info'" aria-hidden="true">
      <svg *ngIf="tone === 'danger'" class="icon" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M3 6h18" />
        <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
      </svg>
      <svg *ngIf="tone === 'info'" class="icon" viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="9" />
        <line x1="12" y1="8" x2="12" y2="8.01" />
        <line x1="12" y1="12" x2="12" y2="16" />
      </svg>
    </span>

    <h2 id="confirm-dialog-title" class="dialog-title">{{ title }}</h2>
    <p *ngIf="message" id="confirm-dialog-body" class="dialog-body">{{ message }}</p>

    <div class="dialog-actions">
      <button #cancelBtn type="button" class="btn btn-secondary" (click)="onCancel()">
        {{ cancelLabel }}
      </button>
      <button
        type="button"
        class="btn"
        [ngClass]="tone === 'danger' ? 'btn-danger-solid' : 'btn-primary'"
        (click)="onConfirm()"
      >
        {{ confirmLabel }}
      </button>
    </div>
  </div>
</div>
